import React from "react";
import safety from "./assets/images/whychooseus/safety.webp";
import time from "./assets/images/whychooseus/time.webp";
import driver from "./assets/images/whychooseus/driver.webp";
import price from "./assets/images/whychooseus/price.webp";
import calender from "./assets/images/whychooseus/calendar.webp";
import customerservice from "./assets/images/whychooseus/customerservice.webp";
import Testimonials from "./Testimonials";
import { IoCarSportSharp } from "react-icons/io5";
import { CgSmileMouthOpen } from "react-icons/cg";
import { FaRoute } from "react-icons/fa6";

function Hero2() {
  return (
    <>
      <div className="container">
        <div className="stats-section mt-4 mobileview">
          <div className="stats-card gradient-1 mb-2">
            <div className="stats-icon icon-1">
              <IoCarSportSharp />
            </div>
            <h2 className="text-1">8,200+</h2>
            <p className="text-1">Local Rides</p>
            <span className="stats-badge text-1">Completed</span>
          </div>

          <div className="stats-card gradient-2 mb-2">
            <div className="stats-icon icon-2">
              <FaRoute />
            </div>
            <h2 className="text-2">3,450+</h2>
            <p className="text-2">Outstation Rides</p>
            <span className="stats-badge text-2">This Year</span>
          </div>

          <div className="stats-card gradient-3 mb-2">
            <div className="stats-icon icon-3">
              <CgSmileMouthOpen style={{ fontSize: "26px" }} />
            </div>
            <h2 className="text-3">11,500+</h2>
            <p className="text-3">Happy Customers</p>
            <span className="stats-badge text-3">And Growing</span>
          </div>
        </div>

        <div className="d-flex align-items-center mt-5">
          <div className="heading-dash" />
          <h5 className="fw-bold mb-0 d-flex align-items-center">
            {/* <SiSitepoint className="me-2" size={20} /> */}
            Why Choose Us
          </h5>
        </div>

        <div className="whychooseus pt-3 pb-3">
          <div className="whychooseus-card">
            <img src={safety} className="img-fluid" />
            <div>
              <h5 className="mb-2">Safety First, Always</h5>
              <p>
                Your safety comes first, well-maintained vehicles and trained
                drivers ensuring a smooth ride.
              </p>
            </div>
          </div>

          <div className="whychooseus-card">
            <img src={time} className="img-fluid" />
            <div>
              <h5>Guaranteed Punctuality</h5>
              <p>On-time pickups and drop-offs - because your time matters.</p>
            </div>
          </div>

          <div className="whychooseus-card">
            <img src={driver} className="img-fluid" />
            <div>
              <h5>Skilled Local Driver</h5>
              <p>
                Experienced drivers with deep local knowledge to ensure the
                fastest and most efficient routes.
              </p>
            </div>
          </div>

          <div className="whychooseus-card">
            <img src={price} className="img-fluid" />
            <div>
              <h5>Fair & Transparent Pricing</h5>
              <p>Clear, competitive fares with absolutely no hidden costs.</p>
            </div>
          </div>

          <div className="whychooseus-card">
            <img src={calender} className="img-fluid" />
            <div>
              <h5>Flexible Ride Plans</h5>
              <p>
                Whether you need a ride for an hour, a full day, or longer - we
                adapt to your schedule.
              </p>
            </div>
          </div>

          <div className="whychooseus-card">
            <img src={customerservice} className="img-fluid" />
            <div>
              <h5>24/7 Customer Support</h5>
              <p>
                Round-the-clock assistance for bookings, queries, and in-ride
                support whenever you need us.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Testimonials />
    </>
  );
}

export default Hero2;
